import { createSlice } from '@reduxjs/toolkit';


function defaultBackground(state, backgroundId, loading = false, loaded = true) {
  if (state[backgroundId]) return;
  state[backgroundId] = {
    loading,
    loaded,
    error: false,
    data: null,
  }
}

const getInitialState = () => ({})

const configuratorViewBackground = createSlice({
  name: 'configuratorViewBackground',
  initialState: getInitialState(),
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    fetchBackgroundStart: (state, { payload }) => {
      const { id } = payload;
      defaultBackground(state, id, true, false)
      state[id].loading = true;
      state[id].loaded = true;
      state[id].error = false;
      state[id].data = null;
    },
    fetchBackgroundSuccess: (state, { payload }) => {
      const { id, data } = payload;
      defaultBackground(state, id);
      state[id].loading = false
      state[id].loaded = true;
      state[id].error = false;
      state[id].data = data;
    },
    fetchBackgroundFailed: (state, { payload }) => {
      const { id } = payload;
      defaultBackground(state, id);
      state[id].loading = false
      state[id].loaded = true;
      state[id].error = true;
      state[id].data = null;
    },
    updateBackground: (state, { payload }) => {
      if (!state[payload.id]) return;
      state[payload.id].data = {
        ...state[payload.id].data,
        ...payload,
      }
    }
  },
});

export const configuratorViewBackgroundActions = configuratorViewBackground.actions;
export const configuratorViewBackgroundReducer = configuratorViewBackground.reducer;

export const selectBackgroundLoading = (id) => (state) => Boolean(state.configuratorViewBackground[id]?.loading)
export const selectBackgroundLoaded= (id) => (state) => Boolean(state.configuratorViewBackground[id]?.loaded)
export const selectBackgroundError = (id) => (state) => state.configuratorViewBackground[id]?.error
export const selectBackgroundData = (id) => (state) => state.configuratorViewBackground[id]?.data